module.exports = __webpack_public_path__ + "assets/img/beijing.a21d20f3.png";